import styled from "styled-components";

interface IIconBg {
  color?: string
}

interface IIconWrapp {
  isShowed: boolean
}

export const Container = styled.div`
  margin: 36px auto 0;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 980px) {
    flex-direction: row;
    margin: 40px auto 0;
    align-items: center;
  }
  
  @media (min-width: 1280px) {
    width: 1150px;
  }
`

export const Left = styled.div`
  order: 2;
  
  @media (min-width: 980px) {
    flex: 0 0 55%;
    order: 1;
    margin-bottom: 0;
  }
`

export const Right = styled.div`
  order: 1;
  margin-bottom: 40px;
  
  @media (min-width: 980px) {
    margin-bottom: 0;
    flex: 0 0 45%;
    order: 2;
  }
`

export const IconWrapp = styled.div<IIconWrapp>`
  padding: 0 72px 40px 0;
  position: relative;
  transition: opacity .4s ease-in-out, transform .2s ease-in-out;

  ${({ isShowed }) => isShowed && `
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    top: auto;
    left: auto;
    position: relative;
  ` || `
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    position: absolute;
    top: -9999px;
    left: -9999px;
  `};

  @media (min-width: 980px) {
    padding: 0 94px 0 0;
    margin-left: 70px;
  }
`

export const IconBg = styled.div<IIconBg>`
  background: ${({ color }) => color && color || '#fff'};
  border-radius: 10px;
  height: 93px;
  
  @media (min-width: 980px) {
    height: 386px;
    border-radius: 40px;
    width: 264px;
  }
`

export const IconPlace = styled.div`
  position: absolute;
  top: 37px;
  right: 0;
  left: 85px;
  bottom: 0;
  background: #FFFFFF;
  border: 1px solid #C4BFD4;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 58px;
    height: auto;
  }

  @media (min-width: 980px) {
    top: 66px;
    bottom: 66px;
    left: 94px;
    height: auto;
    width: 344px;
    border-radius: 20px;

    img {
      width: auto;
      height: auto;
    }
  }
`